import styled from "styled-components";
import { appear } from "../../../../newUXPages/InformaAcademy/components/CompleteCourse/styles";

export const Container = styled.div`
  border-radius: 8px;
  margin-top: 24px;
  border: 1px solid rgba(0, 34, 68, 0.31);
  height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  color: #002244;
  animation: ${appear} 500ms;

  & > p {
    margin-bottom: 0;
    font-family: "Open Sans";
    font-size: 32px;
    width: 40%;
    text-align: center;
    line-height: 100%;
  }
`;
